var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7917 12.0417V0.375H6.20833V6.20833H0.375V26.625H12.0417V20.7917H14.9583V26.625H26.625V12.0417H20.7917ZM6.20833 23.7083H3.29167V20.7917H6.20833V23.7083ZM6.20833 17.875H3.29167V14.9583H6.20833V17.875ZM6.20833 12.0417H3.29167V9.125H6.20833V12.0417ZM12.0417 17.875H9.125V14.9583H12.0417V17.875ZM12.0417 12.0417H9.125V9.125H12.0417V12.0417ZM12.0417 6.20833H9.125V3.29167H12.0417V6.20833ZM17.875 17.875H14.9583V14.9583H17.875V17.875ZM17.875 12.0417H14.9583V9.125H17.875V12.0417ZM17.875 6.20833H14.9583V3.29167H17.875V6.20833ZM23.7083 23.7083H20.7917V20.7917H23.7083V23.7083ZM23.7083 17.875H20.7917V14.9583H23.7083V17.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteWhite);
export default __webpack_public_path__ + "static/media/site_white.098e4131697091320643111e6fe6c9ba.svg";
export { ForwardRef as ReactComponent };